import { useMutation } from "@tanstack/react-query";
import { apiV1Endpoint } from "../../../../../../api/v1";
import { ApiResponse } from "../../../../../../types/api-response";
import axios from "../../../../../../utils/axiosInceptor";

export type AddCreditNoteRequest = {
  pdcId: string;
  creditNote: {
    amountToCredit: number;
    creditDate: string;
    note: string;
  };
};

const addCreditNoteRequest = async (payload: AddCreditNoteRequest) => {
  const url = `${apiV1Endpoint}/booking/addCreditNote`;

  const response = await axios.post<ApiResponse>(url, payload);
  return response.data.result;
};

type UseAddCreditNoteOptions = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useAddCreditNote = (options: UseAddCreditNoteOptions = {}) => {
  const { onSuccess, onError } = options;

  const { mutateAsync, isPending } = useMutation({
    mutationFn: addCreditNoteRequest,
    onSuccess,
    onError,
  });

  return {
    addCreditNoteRequest: mutateAsync,
    isPendingAddCreditNoteRequest: isPending,
  };
};
